import React, { Component } from 'react'
import { BrowserRouter, Switch, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'

// App Route Components
import PublicRoute from './components/Routes/PublicRoute'
import PortalRoute from './components/Routes/PortalRoute'

// Global
import SVGSprite from './components/Global/SVGSprite'
import ModalConductor from './components/Modals/ModalConductor'
import ModalCurtain from './components/Modals/ModalCurtain'

// Onboarding
import SignUp from './screens/Onboarding/SignUp'
import ManageMaintainerRequest from './screens/Onboarding/ManageMaintainerRequest'
import DeclineMaintainerInvitation from './screens/Onboarding/DeclineMaintainerInvitation'

// Sessions
import LogIn from './screens/Sessions/LogIn'
import LogOut from './screens/Sessions/LogOut'
import ResetPassword from './screens/Sessions/ResetPassword'
import ChoosePassword from './screens/Sessions/ChoosePassword'

// Application
import PlayerProfile from './screens/Profile/PlayerProfile'

// User Portal
import Dashboard from './screens/UserPortal/Dashboard'
import CoachSearchResults from './screens/UserPortal/CoachSearchResults'
import Coach from './screens/UserPortal/Coach'

// User Portal - Locker
import LockerPortal from './screens/UserPortal/Locker/LockerPortal'

// User Portal Resource LIBRARY
import ResourceLibraryArchive from './screens/UserPortal/ResourceLibrary/ResourceLibraryArchive'
import ResourceLibrarySingle from './screens/UserPortal/ResourceLibrary/ResourceLibrarySingle'

// User Portal Settings
import SettingsRedirect from './screens/UserPortal/Settings/SettingsRedirect'
import AthleteInfo from './screens/UserPortal/Settings/AthleteInfo'
import AccountInfo from './screens/UserPortal/Settings/AccountInfo'
import PaymentInfo from './screens/UserPortal/Settings/PaymentInfo'
import UpdatePaymentInfo from './screens/UserPortal/Settings/UpdatePaymentInfo'
import CancelSubscription from './screens/UserPortal/Settings/CancelSubscription'
import PaymentInfoSubscribe from './screens/UserPortal/Settings/PaymentInfoSubscribe'
import AccountAdmins from './screens/UserPortal/Settings/AccountAdmins'

// Terms & Privacy
// import TermsOfUse from './screens/TermsPrivacy/TermsOfUse'
// import PrivacyPolicy from './screens/TermsPrivacy/PrivacyPolicy'
// import RefundPolicy from './screens/TermsPrivacy/RefundPolicy'

// Feedback
// import FeedbackForm from './screens/FeedbackForm'

// 404
import PageNotFound from './screens/PageNotFound'

// Admin
import AdminProfile from './screens/Admin/AdminProfile'
import AdminProfileList from './screens/Admin/AdminProfileList'
import AdminUsersList from './screens/Admin/AdminUsersList'

// Actions
import {
  hideModal,
  showModal,
} from './actions/modal'

import {
  getUpdatedUser,
} from './actions/user'

class App extends Component {

  componentDidMount() {
    this.props.hideAllPreviousModals()
  }

  render() {
    const appName = "Locker Linked"
    const { modalShown } = this.props.modal
    const { user, accountDetails } = this.props

    return (
      <div id="app">
        <SVGSprite />
        <BrowserRouter>
          <Switch>

            {/* Error Pages */}
            <PublicRoute exact path="/404"
              component={PageNotFound}
              appName={appName}
            />

            {/* Onboarding */}
            <PublicRoute
              exact path="/sign-up/:form?/:token?"
              component={SignUp}
              appName={appName}
              scrollToTop={true}
            />

            {/* Sessions */}
            <PublicRoute
              exact path="/log-in/"
              component={LogIn}
              appName={appName}
              scrollToTop={true}
            />

            <PublicRoute
              exact path="/log-out/"
              component={LogOut}
              appName={appName}
              scrollToTop={true}
            />

            <PublicRoute
              exact path="/reset-password/"
              component={ResetPassword}
              appName={appName}
              scrollToTop={true}
            />

            <Redirect exact from="/choose-password" to="/reset-password" push />
            <PublicRoute
              path="/choose-password/:token"
              component={ChoosePassword}
              appName={appName}
              scrollToTop={true}
            />

            {/* Maintainer Management */}
            <PublicRoute
              path="/maintainer-request/:token/:selectedResponse"
              component={ManageMaintainerRequest}
              appName={appName}
              scrollToTop={true}
            />

            <PublicRoute
              path="/decline-invitation/:token"
              component={DeclineMaintainerInvitation}
              appName={appName}
              scrollToTop={true}
            />

            {/* Admin */}
            <PortalRoute
              exact path="/admin/profiles/:username"
              component={AdminProfile}
              appName={appName}
              authenticated={user}
              scrollToTop={true}
            />

            <PortalRoute
              exact path="/admin/profiles"
              component={AdminProfileList}
              appName={appName}
              authenticated={user}
              scrollToTop={true}
            />

            <PortalRoute
              exact path="/admin/users"
              component={AdminUsersList}
              appName={appName}
              authenticated={user}
              scrollToTop={true}
            />

            {/* User Portal */}
            <PortalRoute
              exact path="/"
              component={Dashboard}
              appName={appName}
              authenticated={user}
              user={user}
              accountDetails={accountDetails}
            />

            <PortalRoute
              exact path="/colleges/coaches"
              component={CoachSearchResults}
              appName={appName}
              authenticated={user}
            />

            <PortalRoute
              exact path="/colleges/coaches/:coachId?"
              component={Coach}
              appName={appName}
              authenticated={user}
              scrollToTop={true}
            />

            <PortalRoute
              exact path="/resource-library/:category/"
              component={ResourceLibraryArchive}
              appName={appName}
              authenticated={user}
              scrollToTop={true}
            />

            <PortalRoute
              exact path="/resource-library/:category/:articleId"
              component={ResourceLibrarySingle}
              appName={appName}
              authenticated={user}
              scrollToTop={true}
            />

            {/* User Portal – Locker */}
            <PortalRoute
              path="/locker/:sport?/:section?"
              component={LockerPortal}
              appName={appName}
              authenticated={user}
            />

            {/* User Portal – Settings*/}
            <PortalRoute
              exact path="/settings/"
              component={SettingsRedirect}
              appName={appName}
              authenticated={user}
            />
            <PortalRoute
              exact path="/settings/athlete-info"
              component={AthleteInfo}
              appName={appName} authenticated={user}
            />
            <PortalRoute
              exact path="/settings/account-info"
              component={AccountInfo}
              appName={appName} authenticated={user}
            />
            <PortalRoute
              exact path="/settings/payment-info/"
              component={PaymentInfo}
              appName={appName} authenticated={user}
            />
            <PortalRoute
              exact path="/settings/payment-info/confirmed"
              component={PaymentInfo}
              appName={appName}
              authenticated={user}
            />
            <PortalRoute
              exact path="/settings/payment-info/update"
              component={UpdatePaymentInfo} appName={appName}
              authenticated={user}
            />
            <PortalRoute
              exact path="/settings/payment-info/cancel-subscription"
              component={CancelSubscription} appName={appName}
              authenticated={user}
            />
            <PortalRoute exact path="/settings/payment-info/subscribe"
              component={PaymentInfoSubscribe}
              appName={appName}
              authenticated={user}
            />
            <PortalRoute
              exact path="/settings/account-admins"
              component={AccountAdmins}
              appName={appName}
              authenticated={user}
            />

            {/* Profile */}
            <PublicRoute
              path="/:username/:sportSlug?/:section?"
              component={PlayerProfile}
              appName={appName}
            />

          </Switch>
        </BrowserRouter>
        {modalShown && <ModalConductor /> }
        {modalShown && <ModalCurtain />}
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    modal: state.modal,
    user: state.user,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    hideAllPreviousModals: modalType => {
      dispatch(hideModal())
    },
    showModal: (type) => dispatch(showModal(type)),
    getUpdatedUser: (user) => {
      dispatch(getUpdatedUser(user))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App)



// WEBPACK FOOTER //
// ./src/App.js